import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/IubendaPolicyEmbed.tsx");
